import { Link } from 'react-router'

import { paths } from '@/app/navigation'
import { env } from '@/config/env'
import { IMAGES } from '@/constants'

/** App logo linking to Projects. `compact` shows the icon-only mark (used in the sidebar rail). */
export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to={paths.projects} className="flex items-center rounded-lg" aria-label={env.appName}>
      {compact ? (
        <img src={IMAGES.logo} alt="" className="size-9 shrink-0 object-contain" />
      ) : (
        <img src={IMAGES.appLogo} alt="" className="h-8 w-auto shrink-0" />
      )}
    </Link>
  )
}
